import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { DefaultMenuState, MenuContext } from '../../utils/contexts/contexts';
import { NavBar } from '../NavBar';
import { UnauthorizedOverlay } from './UnauthorizedOverlay';

type PageWrapperProps = {
  Content: React.ComponentType<any>;
};

export const PageWrapper = ({ Content }: PageWrapperProps) => {
  const [menuOpen, setMenuOpen] = useState(DefaultMenuState.menuOpen);
  const [showUnauthorized, setShowUnauthorized] = useState(false);

  useEffect(() => {
    const markUnauthorized = () => setShowUnauthorized(true);

    const onRejection = (e: PromiseRejectionEvent) => {
      const err = e.reason;
      if (err?.response?.status === 401 || err?.status === 401) {
        setShowUnauthorized(true);
        e.preventDefault();
      }
    };

    window.addEventListener('unauthorized', markUnauthorized);
    window.addEventListener('unhandledrejection', onRejection);
    return () => {
      window.removeEventListener('unauthorized', markUnauthorized);
      window.removeEventListener('unhandledrejection', onRejection);
    };
  }, []);

  const toggleMenuState = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <MenuContext.Provider
      value={{
        menuOpen,
        setMenuOpen,
        toggleMenuState,
      }}
    >
      {showUnauthorized && <UnauthorizedOverlay />}

      <NavBar />
      <Box sx={{ display: 'flex', minHeight: '100vh', pt: 'var(--nav-height)', bgcolor: 'var(--bg-main)' }}>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            minHeight: 'calc(100vh - var(--nav-height))',
            bgcolor: 'var(--bg-main)',
            px: 'var(--space-page-x)',
            py: 'var(--space-page-y)',
            width: '100%',
          }}
        >
          <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflowX: 'hidden', width: '100%' }}>
            <Content />
          </Box>
        </Box>
      </Box>
    </MenuContext.Provider>
  );
};

export default PageWrapper;
